import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    getListSettingFormatFile(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    getSettingFormatFile(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    getListFormatFileWithoutLimit(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    createOrUpdateSettingFile(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    getListFields(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    enableFormatFile(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }

    downloadFormatFile(path: string, params: any): Promise<any> {
        return super.getPromisePDF(path, params)
    }

    exportFile(path: string, params: any): Promise<any> {
        return super.getPromisePDF(path, params)
    }
    importFile(path: string, params: any): Promise<any> {
        return super.postPromiseImport(path, params)
    }
})()